import React from "react";
import { PaginationInterface } from "../Util/Interface";
import Classic from "./Classic";
import Style1 from "./Style1";
import { defaultPageOptions } from "../Util/Constant";

export default function Pagination({
  params,
  updateParams = () => undefined,
  paginationPlacement = "right",
  paginationWrapperClass = "",
  paginationStyle = "classic",
  prevText = "",
  nextText = "",
  prevIcon = null,
  nextIcon = null,
  paginationButtonClass = "",
  pageOptions = defaultPageOptions,
}: PaginationInterface) {
  return paginationStyle === "classic" ? (
    <Classic
      params={params}
      updateParams={updateParams}
      paginationPlacement={paginationPlacement}
      paginationWrapperClass={paginationWrapperClass}
      pageOptions={pageOptions}
      prevText={prevText}
      nextText={nextText}
      prevIcon={prevIcon}
      nextIcon={nextIcon}
      paginationButtonClass={paginationButtonClass}
    />
  ) : paginationStyle === "style1" ? (
    <Style1
      params={params}
      updateParams={updateParams}
      paginationPlacement={paginationPlacement}
      paginationWrapperClass={paginationWrapperClass}
      prevText={prevText}
      nextText={nextText}
      prevIcon={prevIcon}
      nextIcon={nextIcon}
      paginationButtonClass={paginationButtonClass}
      pageOptions={pageOptions}
    />
  ) : null;
}
